'use strict';

angular.module('eva2-angular').filter('replaceSpaceWithDash', function() {
  return function(input) {
    return (input) ? input.replace(/\s/g, '-') : '';
  };
});
